import React, { useRef, useState, useEffect } from "react";
import { Nav, Navbar, Stack, Form } from 'react-bootstrap';
import { LinkContainer } from "react-router-bootstrap";
import { useHistory } from "react-router-dom";
import { onError } from "../libs/errorLib";
import { useFormFields } from "../libs/hooksLib";
import axiosInstance from "../axiosApi";
import LoaderButton from "../components/LoaderButton";
import DropdownSelector from "../components/DropdownSelector";
import { useTranslation } from 'react-i18next';

function RoboCarNew() {
  const { t } = useTranslation();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [fields, handleFieldChange] = useFormFields({
    carname: "",
    car_status: "",
    route: "",
    station: "",
  });
  
  const [routeOptions, setRouteOptions] = useState([]);
  const [stationOptions, setStationOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([
    { name: "대기",id: "A"},
    { name: "배차",id: "B"},,
    { name: "수리",id: "C"},
  ]);
  
  useEffect(() => {
    async function onLoad() {
      try {
        await axiosInstance.get('/robotaxi/route/').then(function(response) {
          //console.log(response.data);
          const routes = response.data;
          setRouteOptions(routes.map( data => ({ name: data.routename, id: data.id, route:data} ) ));
        }).catch(function (error) {
          if ( error.response.status === 444 ) {
            onError(error.response.data.message);
          } else {
            onError(error);
          }
        });
        
        await axiosInstance.get('/robotaxi/station/').then(function(response) {
          //console.log(response.data);
          const stations = response.data;
          setStationOptions(stations.map( data => ({ name: data.stationname, id: data.id, station:data }) ));
        }).catch(function (error) {
          if ( error.response.status === 444 ) {
            onError(error.response.data.message);
          } else {
            onError(error);
          }
        });
        
      } catch (e) {
        onError(e);
      }
    }
    
    onLoad();
  }, []);
  
  function validateForm() {
    return (
      fields.carname.length > 0
    );
  }
  
  function createCar(car) {
    console.log(car);
    axiosInstance.post(`/robotaxi/robocar/`, car).then(function(response) {
      return;
    }).catch(function (error) {
      //console.log(error);
      if ( error.response.status === 444 ) {
        onError(error.response.data.message);
      } else {
        onError(error);
      }
      setIsLoading(false);
    }); 
  }
  
  async function handleSubmit(event) {
    event.preventDefault();

    setIsLoading(true);

    try {
      await createCar({
        carname: fields.carname,
        car_status: fields.car_status,
        route: fields.route,
        station: fields.station,
      });
    
      history.push("/robocar");
    } catch (e) {
      onError(e);
      setIsLoading(false);
    }
  }
  
  function onChangeRoute(event) {
    const result = routeOptions.find(option => Number(option.id) === Number(event.target.value));
    fields.route = result.route;
    //this.setState({ selectedValue: event.target.value });
  };
  
  function onChangeStation(event) {
    const result = stationOptions.find(option => Number(option.id) === Number(event.target.value));
    fields.station = result.station;
    //this.setState({ selectedValue: event.target.value });
  };
  
  function onChangeState(event) {
    fields.car_status = event.target.value;
    //this.setState({ selectedValue: event.target.value });
  };
  
  return (
  <Stack gap={3}>
      <div className="bg-light border">
        
        <div className="Notes">
          <h3 className="pb-3 mt-4 mb-3 border-bottom">{t('INPUT_SCREEN')}</h3>
            <Form onSubmit={handleSubmit}>
              <Form.Group controlId="carname">
                <Form.Label>차량명</Form.Label>
                <Form.Control
                  type="text"
                  value={fields.carname}
                  onChange={handleFieldChange}
                />
              </Form.Group>
              <Form.Group controlId="car_status">
                <DropdownSelector
                        labelName="상태"
                        options={stateOptions}
                        defaultValue={fields.car_status}
                        onChange={onChangeState}
                />
              </Form.Group>
              <Form.Group controlId="route">
                <DropdownSelector
                        labelName="노선"
                        options={routeOptions}
                        defaultValue={fields.route.id}
                        onChange={onChangeRoute}
                />
              </Form.Group>
              <Form.Group controlId="station">
                <DropdownSelector
                        labelName="정류장"
                        options={stationOptions}
                        defaultValue={fields.station.id}
                        onChange={onChangeStation}
                />
              </Form.Group>
              <LoaderButton
                block
                size="lg"
                type="submit"
                variant="primary"
                isLoading={isLoading}
                disabled={!validateForm()}
              >
                Create
              </LoaderButton>
            </Form>
        </div>
        
      </div>
      <div>
        <br /><br /><br />
      </div>
  </Stack>
  );
}

export default RoboCarNew;